module.exports = __webpack_public_path__ + "static/desktop/img/calendar-4-thumb.541eb037.png";